import { render, staticRenderFns } from "./DataConvertSerial.vue?vue&type=template&id=62a800c4&"
import script from "./DataConvertSerial.vue?vue&type=script&lang=js&"
export * from "./DataConvertSerial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports